import RelationDomainException from '~/modules/Relations/Domain/RelationDomainException'

export default class Relation<T> {
  private readonly instance: T | undefined

  private constructor (instance: T | undefined) {
    this.instance = instance
  }

  public static from<T> (instance: T): Relation<T> {
    return new Relation<T>(instance)
  }

  public static notLoaded<T> (): Relation<T> {
    return new Relation<T>(undefined)
  }

  get value (): T {
    if (this.instance === undefined) {
      throw RelationDomainException.notLoaded()
    }

    return this.instance
  }
}
